import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import HomeBanner from '../components/HomePage/HomeBanner';
import CategorySliderImg from '../components/HomePage/CategorySlider';
import ServiceSliderImg from '../components/HomePage/ServiceSlider';
import RecentTaskSliderImg from '../components/HomePage/RecentTaskSlider';
import BusinessForSaleSlider from '../components/HomePage/BusinessForSaleSlider';
import HowDoesWork from '../components/HomePage/HowDoesWork';
import axios from 'axios';
import MetaDecorator from '../components/MetaDecorator';
import Loader from "react-loader-spinner";
import i18next from "i18next";
import Swal from 'sweetalert2';

const CategorySlider = (i) => {
    return (
        <div className="homeSlide mb-5" key={i.item_id}>
            <div className="mb-2">
                <div className="d-flex justify-content-between">
                    <h5 className="text-truncate fB">{i.title} </h5>
                    {
                        i.cat_items && i.cat_items.length > 4 &&
                        <Link to={"/user/sub-categories/"+i.cat_type.item_id}>
                            <div className="text-right defaultColor font-sm ">{i18next.t('View all')}</div>
                        </Link>
                    }
                </div>
            </div>
            <CategorySliderImg cat_type={i.cat_type} cat_items={i.cat_items} />
        </div>
    )
}





const ServiceSlider = (i) => {
    console.log('serviceInfo',i.services_info);
    
    return (
        <div className="homeSlide mb-5">
            <div className="mb-2">
                <div className="d-flex justify-content-between">
                    <h5 className="text-truncate fB">{i.title} </h5>
                </div>
            </div>
            <ServiceSliderImg service_info = {i.services_info} />
        </div>
    )
}
const RecentTask = (i) => {
    return (
        <div className="recentTasks homeSlide mb-5">
            <div className="mb-2">
                <div className="d-flex justify-content-between">
                    <h5 className="text-truncate fB">{i.title} </h5>
                    <Link to="/RecentTask/viewall">
                        <div className="text-right defaultColor font-sm "></div>
                    </Link>
                </div>
            </div>
            <RecentTaskSliderImg recent_bookings = {i} />
        </div>
    )
}

const BusinessSlider = ({business,title}) => {
    return (
        <div className="recentTasks homeSlide mb-5">
            <div className="mb-2">
                <div className="d-flex justify-content-between">
                    <h5 className="text-truncate fB">{ title }</h5>
                    <Link to= {{
                        pathname: "/business/viewall",
                        state: { businesses: business } // Pass the business data here
                    }}>
                        <div className="text-right defaultColor fM">{i18next.t('View all')}</div>
                    </Link>
                </div>
            </div>
            <BusinessForSaleSlider businesses={business} title={ title } />
        </div>
    )
}
class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            home : {},
            feature_items : [],
            feature_page : 0,
            is_loading : true,
            has_loadmore : true,
            business_for_sale: [],

        }
    }
    componentDidMount = () => {
        this.get_home_page_contents();
        this.get_feature_items();
        this.get_business_for_sale(); // Fetch business-for-sale data

    }
   


    get_business_for_sale = () => {
        console.log("Fetching from:", `${process.env.REACT_APP_BASE_URL}/web/api/v1/user/business_for_sale`);
        axios.get(`${process.env.REACT_APP_BASE_URL}/web/api/v1/user/business_for_sale`)
            .then((res) => {
                console.log('BURES',res.data.business_for_sale);
                if (res.data.status_code === 200) {
                    this.setState({ business_for_sale: res.data.business_for_sale }, () => {
                        console.log("Fetched business for sale:", this.state.business_for_sale);
                    });
                } else if (res.data.status_code === 401) {
                    localStorage.removeItem('user');
                    localStorage.removeItem('access_token');
                    this.props.history.push('/');
                    window.location.reload(false);
                }else if (res.data.status_code === 404) {
                    Swal.fire({
                        title: i18next.t('Error'),
                        text: i18next.t('No business for sale records found.'),
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                console.error('Error fetching business for sale:', err);
            });
    };
    

    get_home_page_contents = () => {
        var user_id = '';
        if(localStorage.getItem('user') === null) {
            user_id = '';
        }
        else {
            var user_info = JSON.parse(localStorage.getItem('user'));
            user_id = user_info.user_id;
        }
        const config = {
            headers : {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
        const params = new URLSearchParams();
        params.append('user_id' , user_id);
        axios.post(`${process.env.REACT_APP_BASE_URL}/web/api/v1/user/home` , params, config)
        .then(res=>{
            if(res.status === 200) {
                if(res.data.status_code === 200) {
                    this.setState({home:res.data},()=>{
                        if(res.data.client_ip_address) {
                            localStorage.setItem('ip_address',res.data.client_ip_address);
                        }
                    });
                }
                else if(res.data.status_code === 401) {
                    localStorage.removeItem('user');
                    localStorage.removeItem('access_token');
                    this.props.history.push('/');
                    window.location.reload(false);
                }else if (res.data.status_code === 404) {
                    Swal.fire({
                        title: i18next.t('Error'),
                        text: i18next.t('No business for sale records found.'),
                        icon: 'error',
                    });
                }
            }
            else {
                alert("404! , Page Not Responsive!");
            }
        })
        .catch((err)=>{
            console.log('errrrrrrrrrrrrrrrr ',err)
        }) 
    }
    get_feature_items = () => {
        var feature_page = this.state.feature_page;
        axios.get(`${process.env.REACT_APP_BASE_URL}/web/api/v1/user/get_home_feature_items/${feature_page}/10`)
        .then (res=>{
            console.log('result category');
            console.log(res);
            if(res.data.status_code === 200) {
                var all_feature_items = this.state.feature_items;
                all_feature_items.push(res.data.feature_items);
                const newData = all_feature_items.flat();
                this.setState({ 
                    feature_items : newData,
                });
                var rm = this;
                setTimeout(function(){ 
                    rm.setState({
                        is_loading : false
                    })
                }, 1800);
                if(res.data.feature_items.length === 0 || res.data.feature_items.length < 10) {
                    this.setState({
                        has_loadmore : false
                    })
                }
            }
            else if(res.data.status_code === 401) {
                localStorage.removeItem('user');
                localStorage.removeItem('access_token');
                this.props.history.push('/');
                window.location.reload(false);
            }
        });
    }
    render() {
        return (
            <React.Fragment>
                <div className={ this.state.is_loading === true ?  "loadercls"  : "" }>
                <MetaDecorator title=' | Home Service Categories and Lists' description="Book your needs, customize your price with taskers" />
                {
                    this.state.is_loading === true ?
                    <div>
                        <Loader
                            type="ThreeDots"
                            color="#FF5800"
                            height={100}
                            width={100}
                        />
                    </div>
                    :
                    <>
                    <HomeBanner banners={this.state.home.banner_items}/>
                
                
                    <div className="container" style={{}}>
                        {/* Categorys Slider */}
                        <div className="mt-4">

                            <ServiceSlider services_info={this.state.home.category_items} title={ i18next.t('Services') }  />
                           
                            {
                                typeof this.state.home.recent_items !== 'undefined' && this.state.home.recent_items.length > 0 &&
                                    <RecentTask recent_tasks={this.state.home.recent_items} title={ i18next.t('Recent Tasks') } />
                            }
                            {/* {
                                this.state.feature_items &&
                                this.state.feature_items.map((cat) => {
                                    return cat.items && cat.items.length > 0 && (
                                        <CategorySlider cat_type = {cat} cat_items={cat.items} title={cat.item_name} key={cat.item_id} />
                                    )
                                })
                            } */}
                            {/* <LoadMore/> */}



                              {/* Business for Sale Section */}


                                {this.state.business_for_sale.length > 0 && (
                                <BusinessSlider business={this.state.business_for_sale} title={ i18next.t('Business for Sale') } />
                                )}
                              
                            {
                                this.state.has_loadmore === true &&
                                <div className="m-3">
                                    <button onClick={ (e)=> { e.stopPropagation(); this.setState({ feature_page : this.state.feature_page + 10 },()=> {
                                        this.get_feature_items();
                                    });   }  } type="button" className="loadMoreServices border-0 w-100 md">{ i18next.t('Load more') }</button>
                                </div>
                            }
                            
                            <HowDoesWork />
                        </div>
                    </div>
                    </>
                }
                
                </div>
            </React.Fragment>
        );
    }
}

export default Home;